module.exports = __webpack_public_path__ + "static/img/4软硬件平台化设计-on.2a39fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/4软硬件平台化设计-on.png
// module id = fVRU
// module chunks = 0